export class UtilButton {
  parent: HTMLElement;
  label: string;
  button: HTMLButtonElement;
  btnClass: string;
  constructor(parent: HTMLElement, label = "Label", btnClass = "btn-primary") {
    this.parent = parent;
    this.btnClass = btnClass;
    this.label = label;
    this.button = this.createButton();
    parent.appendChild(this.button);
  }

  createButton() {
    const button = document.createElement("button");
    button.innerHTML = this.label;
    button.classList.add("btn", this.btnClass);
    return button;
  }
}
